import { render, staticRenderFns } from "./AcceptTender.vue?vue&type=template&id=4b630cb8&"
import script from "./AcceptTender.vue?vue&type=script&lang=js&"
export * from "./AcceptTender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports